import { render } from "./HeaderButtons.vue?vue&type=template&id=260089b3&scoped=true"
import script from "./HeaderButtons.vue?vue&type=script&lang=js"
export * from "./HeaderButtons.vue?vue&type=script&lang=js"

import "./HeaderButtons.vue?vue&type=style&index=0&id=260089b3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260089b3"]])

export default __exports__